import EmployeeSearchResultItemV2 from "./EmployeeSearchResultItemV2";

export default EmployeeSearchResultItemV2;
